/**
 * The Odoo descriptor the backend carries, for where the catalog has none:
 * the base configuration and the overlays whose `catalog.rules` do not allow
 * the `AppType` kind (ludo's allows it from the platform-catalog location,
 * local development's `app-config.yaml` from any), a failed reading of the
 * catalog, and the pre-engine descriptor (backend `descriptors.ts`).
 * Odoo's configuration then works everywhere exactly as before the engine.
 *
 * `embedded/odoo.apptype.json` is platform-catalog's `apps/odoo/apptype.yaml`
 * as JSON, imported as the schema is (`resolveJsonModule`) rather than read
 * from disk at run time — the same descriptor as the backend's
 * `extensions/appTypes/__fixtures__/odoo.apptype.yaml` — a backend test
 * (`plugins/shared/configEngine/descriptor.test.ts`) holds both equal,
 * the whole entity and its key order.
 * Change them together, from platform-catalog.
 */

import odooAppType from './embedded/odoo.apptype.json';
import {
  compileDescriptor,
  type AppTypeDescriptor,
  type AppTypeSource,
} from './descriptor';

/**
 * The whole entity as embedded (apiVersion, kind, metadata, spec), for the
 * backend test that holds it equal to its fixture, key order included.
 */
export const EMBEDDED_ODOO_ENTITY: unknown = odooAppType;

/** The embedded Odoo descriptor as written, before compilation. */
export const EMBEDDED_ODOO_APP_TYPE: AppTypeSource = {
  name: odooAppType.metadata.name,
  title: odooAppType.metadata.title,
  spec: odooAppType.spec,
};

let odoo: AppTypeDescriptor | undefined;

/** The embedded Odoo descriptor, compiled once (a defect throws at once). */
export function embeddedOdooDescriptor(): AppTypeDescriptor {
  odoo ??= compileDescriptor(EMBEDDED_ODOO_APP_TYPE);
  return odoo;
}
